module.exports = __WEBPACK_EXTERNAL_MODULE_85__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"axios","commonjs2":"axios","amd":"axios","root":"axios"}
// module id = 85
// module chunks = 0